import { ConfigProvider } from 'antd';
import zhTW from 'antd/locale/zh_TW';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import { useTranslation } from 'react-i18next';
import type { Locale } from 'antd/es/locale';
import type { ReactNode } from 'react';

const localeMap: Record<string, Locale> = {
  'zh-TW': zhTW,
  'zh-CN': zhCN,
  'en-US': enUS,
};

export default function AntdLocaleProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const antdLocale = localeMap[i18n.language] || zhTW;

  return <ConfigProvider locale={antdLocale}>{children}</ConfigProvider>;
}
